{
  "aboutSubProject": "Om delprosjektet",
  "clusterOperation": "Klyngedrift",
  "noActiveClusterOperation": "Det finns ingen aktiv klyngedrift",
  "previousOperation": "Tidlegare klyngedrift"
}
